import ReactGA4 from 'react-ga4';

const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      // Create a wrapper function that both calls the original callback
      // and sends the metrics to Google Analytics
      const withAnalytics = (metric) => {
        // Call the original callback
        onPerfEntry(metric);
        
        // Send to Google Analytics
        sendToAnalytics(metric);
      };
      
      // Use the wrapper function for all metrics
      getCLS(withAnalytics);
      getFID(withAnalytics);
      getFCP(withAnalytics);
      getLCP(withAnalytics);
      getTTFB(withAnalytics);
    });
  }
};

// Function to send metrics to Google Analytics
const sendToAnalytics = (metric) => {
  const { name, delta, id } = metric;
  
  // Only send to GA in production to avoid skewing analytics data during development
  if (process.env.NODE_ENV === 'production') {
    ReactGA4.event({
      category: 'Web Vitals',
      action: name,
      // Google Analytics expects values to be integers, so we round
      // CLS normally has a very small value, so we multiply it by 1000 for more meaningful data
      value: Math.round(name === 'CLS' ? delta * 1000 : delta),
      label: id,
      nonInteraction: true,
    });
  }
};

export default reportWebVitals;